import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2c3.972 0 7 4.542 7 10s-3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.003 -.297c.107 -5.323 3.097 -9.703 6.997 -9.703z","key":"svg-0"}]]

/**
 * IconOvalFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItb3ZhbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMmMzLjk3MiAwIDcgNC41NDIgNyAxMHMtMy4wMjggMTAgLTcgMTBjLTMuOSAwIC02Ljg5IC00LjM3OSAtNi45OTcgLTkuNzAzbC0uMDAzIC0uMjk3bC4wMDMgLS4yOTdjLjEwNyAtNS4zMjMgMy4wOTcgLTkuNzAzIDYuOTk3IC05LjcwM3oiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/oval-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconOvalFilled = createReactComponent('filled', 'oval-filled', 'OvalFilled', __iconNode);

export default IconOvalFilled;